import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Form/Button';
import FlexGroup from 'components/FlexGroup';
import { Translate } from 'react-redux-i18n';
import {
    AUTH_REVOKE_LINK_PAY,
    AUTH_EDIT_LINK_PAY
} from 'constants/permission';
import AuthFeature from 'components/AuthFeature';
import {
    NONUSER_CHARGE_STATUS_REVOKED,
    REVOKE_NONUSER_CHARGE_WHITELIST,
} from 'constants/nonuser-charge';
import RevokeFee from './RevokeFee';


const ChargeFunctionGroup = ({
    isEdit,
    linkpayDetail,
    onRevoke,
    onChangEdit,
    onEditUpdate,
}) => {
    const {
        status,
        link_pay_id,
    } = linkpayDetail || {};

    const [showRevoke, setShowRevoke] = useState(false);
    const disableRevokeFee = REVOKE_NONUSER_CHARGE_WHITELIST.indexOf(status) === -1;

    const handleRevoke = () => {
        let params;
        let onErrorCallback;
        params = {
            id: link_pay_id,
            status: NONUSER_CHARGE_STATUS_REVOKED,
        };
        onErrorCallback = () => {
            setShowRevoke(false);
        };

        return onRevoke(params).finally(onErrorCallback);
    };

    const handleEditFee = e => {
        onChangEdit(true);
    };
    const handleCancelEdit = e => {
        onChangEdit(false);
    };
    const handleEditUpdate = e => {
        return onEditUpdate();
    };


    return (
        <FlexGroup className="fee-functions">
            {
                isEdit ? (
                    <>
                        <Button
                            type="button"
                            className="btn-cancel"
                            onClick={ handleCancelEdit }
                            outline
                            stopTriggerByTab>
                            <Translate value="cancel" />
                        </Button>
                        <Button
                            color="primary"
                            type="submit"
                            className="btn-save"
                            onClick={ handleEditUpdate }
                            stopTriggerByTab
                        >
                            <Translate value="save" />
                        </Button>
                    </>
                ) : (
                    <>
                        <AuthFeature requiredList={ [AUTH_REVOKE_LINK_PAY] }>
                            <Button
                                type="button"
                                outline
                                className="btn-revoke-fee"
                                disabled={ disableRevokeFee }
                                onClick={ () => setShowRevoke(true) }
                                stopTriggerByTab
                            >
                                <Translate value="additional_fee.revoke_fee" />
                            </Button>
                        </AuthFeature>
                        <AuthFeature requiredList={ [AUTH_EDIT_LINK_PAY] }>
                            {
                                <Button
                                    type="button"
                                    color="primary"
                                    className="btn-edit-fee"
                                    onClick={ handleEditFee }
                                    stopTriggerByTab
                                >
                                    <Translate value="edit" />
                                </Button>
                            }
                        </AuthFeature>
                    </>
                )
            }
            <RevokeFee
                show={ showRevoke }
                onSubmit={ handleRevoke }
                onClose={ () => setShowRevoke(false) }
            />
        </FlexGroup>
    );
};

ChargeFunctionGroup.propTypes = {
    isEdit: PropTypes.bool.isRequired,
    linkpayDetail: PropTypes.shape({}),
    onRevoke: PropTypes.func,
    onChangEdit: PropTypes.func,
    onEditUpdate: PropTypes.func,
};
ChargeFunctionGroup.defaultProps = {
    linkpayDetail: undefined,
    onRevoke: () => {},
    onChangEdit: () => {},
    onEditUpdate: () => {},
};
export default ChargeFunctionGroup;
